export default {
    common: {
        ok: 'OK',
        cancel: 'Anuluj',
        save: 'Zapisz',
        delete: 'Usuń',
        edit: 'Edytuj',
        close: 'Zamknij',
        confirm: 'Potwierdź',
        back: 'Wstecz',
        next: 'Dalej',
        apply: 'Zastosuj',
        done: 'Gotowe',
        loading: 'Ładowanie...',
        error: 'Błąd',
        success: 'Sukces',
        warning: 'Ostrzeżenie',
        info: 'Informacja'
    },
    navbar: {
        home: 'Strona główna',
        history: 'Historia',
        settings: 'Ustawienia',
        profile: 'Profil',
        vacation: 'Urlop',
        scanner: {
            checkIn: 'Wejście',
            bleCheckIn: 'Wejście BLE',
            checkingLocation: 'Sprawdzanie lokalizacji...',
            locationRequired: 'Wymagana lokalizacja'
        }
    },
    settings: {
        title: 'Ustawienia',
        notifications: {
            title: 'Powiadomienia',
            checkInReminders: 'Przypomnienia o wejściu',
            checkInRemindersDesc: 'Przypomnij mi o wejściu przed rozpoczęciem pracy',
            checkOutReminders: 'Przypomnienia o wyjściu',
            checkOutRemindersDesc: 'Przypomnij mi o wyjściu po zakończeniu pracy',
            reminderTime: 'Czas przypomnienia',
            reminderTimeDesc: 'Jak wcześnie wysyłać przypomnienia',
            updated: {
                checkIn: 'Zaktualizowano przypomnienia o wejściu',
                checkOut: 'Zaktualizowano przypomnienia o wyjściu',
                time: 'Zaktualizowano czas przypomnienia'
            }
        },
        bleAttendance: {
            title: 'Obecność Bluetooth',
            enableLabel: 'Włącz obecność BLE',
            enableDesc: 'Automatyczne wykrywanie urządzenia Bluetooth do rejestracji obecności',
            enabled: 'Obecność Bluetooth włączona',
            disabled: 'Obecność Bluetooth wyłączona',
            permissionDenied: 'Odmówiono uprawnień Bluetooth. Włącz w ustawieniach urządzenia.',
            updateFailed: 'Nie udało się zaktualizować ustawienia Bluetooth'
        },
        reminder: {
            minutesBefore: 'Minuty przed',
            minutesAfter: 'Minuty po',
            minutes: {
                one: '1 minuta',
                other: '{count} minut'
            }
        },
        appearance: {
            title: 'Wygląd',
            theme: 'Motyw',
            themeDesc: 'Wybierz preferowany motyw kolorystyczny',
            themeOptions: {
                light: 'Jasny',
                dark: 'Ciemny',
                auto: 'Automatyczny (System)'
            },
            themeChanged: 'Zmieniono motyw na {theme}'
        },
        language: {
            title: 'Język',
            language: 'Język',
            languageDesc: 'Wybierz preferowany język',
            languageChanged: 'Zmieniono język na {language}'
        },
        profile: {
            title: 'Profil',
            workerId: 'ID pracownika',
            name: 'Imię i nazwisko',
            lastSync: 'Ostatnia synchronizacja',
            notAssigned: 'Nie przypisano',
            unknown: 'Nieznany',
            never: 'Nigdy'
        },
        reminderTimeOptions: {
            minutes5: '5 minut',
            minutes10: '10 minut',
            minutes15: '15 minut',
            minutes30: '30 minut',
            hour1: '1 godzina'
        }
    },
    dashboard: {
        title: 'Panel główny',
        checkIn: 'Wejście',
        checkOut: 'Wyjście',
        welcome: 'Witaj',
        currentStatus: 'Aktualny status',
        todayAttendance: 'Obecność dzisiaj',
        totalDays: 'Łącznie dni',
        comingSoon: 'Wkrótce',
        duration: 'Czas pracy',
        shortDuration: 'Za mało',
        onTrack: 'W normie',
        working: 'Pracuje...',
        durationComplete: 'Wykonano',
        notCheckedIn: 'Brak wejścia',
        notYet: 'Jeszcze nie',
        completed: 'Zakończone',
        onTime: 'Na czas',
        late: 'Spóźniony',
        early: 'Wcześnie',
        missingCheckOut: 'Brak wyjścia',
        manualEntry: 'Wpis ręczny',
        vacationUsed: 'Wykorzystano',
        vacationLeft: 'Pozostało',
        attendanceRegistered: 'Obecność zarejestrowana',
        qrValidated: 'Kod QR potwierdzony',
        bleValidated: 'Bluetooth potwierdzony',
        processingBleCheckin: 'Przetwarzanie wejścia Bluetooth...',
        logout: {
            confirm: 'Potwierdź wylogowanie',
            message:
                'Czy na pewno chcesz się wylogować? Będziesz musiał ponownie przypisać swój profil pracownika.',
            cancel: 'Anuluj',
            button: 'Wyloguj'
        }
    },
    history: {
        title: 'Historia',
        noRecords: 'Nie znaleziono rekordów obecności',
        checkInTime: 'Wejście',
        checkOutTime: 'Wyjście',
        labels: {
            duration: 'Czas trwania',
            location: 'Lokalizacja',
            qrCode: 'Kod QR',
            geofence: 'Geostrefa'
        },
        viewToggle: {
            calendar: 'Kalendarz',
            list: 'Lista'
        },
        loading: 'Ładowanie historii obecności...',
        error: 'Nie udało się załadować historii obecności. Spróbuj ponownie.',
        retry: 'Ponów',
        emptyState: 'Brak rekordów obecności w tym okresie.',
        validated: 'Zwalidowano',
        notValidated: 'Nie zwalidowano',
        calendar: {
            prevMonth: 'Poprzedni miesiąc',
            nextMonth: 'Następny miesiąc',
            viewDetailsAtTime: 'Zobacz szczegóły dla {time}'
        },
        status: {
            holiday: 'Święto',
            absence: 'Nieobecność'
        }
    },
    scanner: {
        title: 'Skaner QR',
        scanning: 'Skanowanie...',
        scanSuccess: 'Skanowanie pomyślne',
        scanError: 'Skanowanie nieudane'
    },
    profile: {
        title: 'Profil',
        assignWorker: 'Przypisz pracownika'
    },
    admin: {
        title: 'Panel administratora',
        accessDenied: 'Brak dostępu',
        subtitle: 'Dostęp administracyjny – używaj ostrożnie',
        banner: {
            title: 'TRYB ADMINISTRATORA AKTYWNY',
            description: 'Włączono ustawienia debugowania i funkcje administracyjne. Używaj ostrożnie.'
        },
        debug: {
            banner: {
                title: 'TYLKO DO TESTÓW',
                desc: 'Tryby debugowania omijają zabezpieczenia. Wyłącz przed produkcją.'
            },
            bypass: {
                title: 'Pomiń sprawdzanie geofencingu',
                desc: 'Pozwól na wejście/wyjście z dowolnej lokalizacji'
            },
            staticQr: {
                title: 'Zezwól na statyczny kod QR',
                desc: 'Akceptuj predefiniowany testowy kod QR (nigdy nie wygasa)'
            },
            lastModified: 'Ostatnia modyfikacja:',
            time: {
                never: 'Nigdy',
                justNow: 'Przed chwilą',
                minutes: {
                    one: '1 minutę temu',
                    other: '{count} minut temu'
                },
                hours: {
                    one: '1 godzinę temu',
                    other: '{count} godzin temu'
                }
            }
        },
        prompt: {
            title: 'Uwierzytelnianie administratora',
            description: 'Wprowadź hasło administratora, aby kontynuować',
            passwordLabel: 'Hasło',
            passwordPlaceholder: 'Wpisz hasło administratora',
            unlock: 'Odblokuj panel',
            accessGranted: 'Przyznano dostęp administratora',
            incorrectPassword: 'Nieprawidłowe hasło',
            authFailed: 'Uwierzytelnianie nie powiodło się',
            lockedTitle: 'Konto zablokowane',
            attemptsRemaining: 'Pozostało prób: {count}',
            errors: {
                required: 'Hasło jest wymagane',
                lockedOut: 'Zbyt wiele nieudanych prób. Spróbuj ponownie za {minutes} min.'
            }
        },
        alerts: {
            exit: {
                header: 'Wyjść z trybu administratora',
                message:
                    'Czy na pewno chcesz wyjść z trybu administratora? Aby ponownie wejść, będziesz musiał użyć gestu.',
                confirm: 'Wyjdź z trybu'
            },
            forget: {
                header: 'Usuń pracownika',
                message:
                    'Czy na pewno chcesz usunąć tego pracownika? To wyczyści wszystkie dane lokalne i przywróci aplikację do stanu początkowego. Tej operacji nie można cofnąć.',
                confirm: 'Usuń pracownika'
            },
            resetBundle: {
                header: 'Resetuj paczkę aplikacji',
                message: 'To przywróci aplikację do wbudowanej wersji. Aplikacja zostanie zamknięta i trzeba będzie ją otworzyć ponownie.',
                confirm: 'Resetuj i zamknij'
            }
        },
        cards: {
            manualRecords: {
                title: 'Rekordy ręczne',
                value: 'Zarządzaj obecnością',
                status: 'Twórz, edytuj i usuwaj rekordy',
                open: 'Otwórz rekordy ręczne'
            },
            logs: {
                title: 'Dzienniki systemowe',
                value: 'Aktywność i bezpieczeństwo',
                status: 'Dzienniki aktywności i monitorowanie bezpieczeństwa',
                open: 'Otwórz dzienniki'
            },
            worker: {
                title: 'Bieżący pracownik',
                noWorker: 'Brak przypisanego pracownika',
                id: 'ID',
                assignToContinue: 'Przypisz pracownika, aby kontynuować',
                forget: 'Usuń pracownika',
                workerIdMissing: 'Brak ID pracownika',
                forgotten: 'Pracownik usunięty. Wyczyszczono wszystkie dane lokalne.'
            },
            settings: {
                title: 'Ustawienia',
                value: 'Konfiguruj',
                status: 'Ustawienia aplikacji i opcje debugowania',
                open: 'Otwórz ustawienia'
            },
            system: {
                title: 'System',
                value: 'Odśwież',
                status: 'Dane i status systemu',
                refreshButton: 'Odśwież dane',
                refreshing: 'Odświeżanie wszystkich danych...',
                refreshed: 'Pomyślnie odświeżono wszystkie dane!',
            refreshFailed: 'Nie udało się odświeżyć danych',
            checkSyncStatus: 'Sprawdź status synchronizacji',
            forceMarkPending: 'Wymuś oznaczenie jako oczekujące',
            toasts: {
                syncStatus: 'Dziś: {today} (oczekujące: {pendingToday})\nŁącznie oczekujących: {totalPending}',
                syncStatusFailed: 'Nie udało się sprawdzić statusu synchronizacji',
                noRecordsToday: 'Brak rekordów na dziś',
                markedPending: 'Oznaczono {count} rekord(y) jako oczekujące. Użyj "Odśwież dane", aby zsynchronizować.',
                markPendingFailed: 'Nie udało się oznaczyć rekordów jako oczekujące'
            }
            },
            schedule: {
                title: 'Grafik pracy',
                type: 'Typ',
                duration: 'Czas pracy',
                checkIn: 'Wejście',
                checkOut: 'Wyjście',
                before: 'przed',
                after: 'po',
                maxOffsetStart: 'Maks. przesunięcie startu',
                minOffsetEnd: 'Min. przesunięcie końca',
                days: 'Dni'
            },
            notifications: {
                title: 'Powiadomienia',
                value: 'Test',
                status: 'Wyślij testowe powiadomienie',
                send: 'Wyślij test',
                sent: 'Wysłano testowe powiadomienie! Sprawdź centrum powiadomień.',
                sendFailed: 'Nie udało się wysłać powiadomienia testowego'
            },
            session: {
                started: 'Sesja administratora rozpoczęta'
            }
        },
        geofence: {
        title: 'Podgląd geostrefy',
            status: {
            inside: 'W geostrefie',
            outside: 'Poza geostrefą',
                unknown: 'Nieznany'
            },
            accuracy: {
                label: 'Dokładność GPS',
                meters: 'metrów',
                na: 'brak'
            },
            error: 'Błąd:',
            legend: {
                title: 'Legenda',
            boundary: 'Granica geostrefy',
                currentLocation: 'Bieżąca lokalizacja'
            }
        },
        totp: {
            title: 'Konfiguracja sekretu TOTP',
            subtitle: 'Skonfiguruj współdzielony sekret do weryfikacji kodu QR',
            status: {
                status: 'Status:',
                configured: 'Skonfigurowany',
                notConfigured: 'Nieskonfigurowany',
                lastSynced: 'Ostatnia synchronizacja:',
                secretLength: 'Długość sekretu:',
                characters: '{chars} znaków'
            },
            info: {
                howTo: 'Jak skonfigurować:',
                scanTitle: 'Skanuj kod QR:',
                scanDesc: 'Użyj skanera poniżej, aby zeskanować z aplikacji Generator',
                manualTitle: 'Wpis ręczny:',
                manualDesc: 'Wpisz sekret Base32 bezpośrednio',
                note: 'Obie aplikacje muszą używać tego samego sekretu, aby weryfikacja działała.'
            },
            scan: {
                title: 'Skanuj kod QR z Generatora',
                desc: 'Zeskanuj dowolny kod QR z aplikacji Generator, aby automatycznie wyodrębnić i zapisać sekret.',
                open: 'Otwórz skaner QR',
                modalTitle: 'Skanuj kod QR',
                instructions: 'Umieść kod QR z aplikacji Generator w ramce'
            },
            manual: {
                title: 'Ręczne wprowadzenie sekretu',
                placeholder: 'Wpisz sekret Base32 (np. JBSWY3DPEHPK3PXP)'
            },
            validation: {
                invalidFormat: 'Nieprawidłowy format. Używaj tylko znaków A-Z oraz 2-7.',
                tooShort: 'Sekret jest za krótki. Zalecane minimum to 16 znaków.',
                valid: 'Prawidłowy format Base32'
            },
            actions: {
                save: 'Zapisz sekret',
                update: 'Zaktualizuj sekret',
                clear: 'Wyczyść sekret'
            },
            viewCurrent: 'Pokaż bieżący sekret',
            modal: {
                currentTitle: 'Bieżący sekret TOTP',
                keepSecure: 'Chroń ten sekret! Każdy, kto go posiada, może generować ważne tokeny.',
                copy: 'Kopiuj do schowka'
            },
            test: {
                title: 'Test generowania TOTP',
                desc: 'Wygeneruj token, aby potwierdzić poprawność sekretu. Token powinien odpowiadać temu w aplikacji Generator.',
                generate: 'Wygeneruj token testowy',
                currentToken: 'Bieżący token:',
                validFor: 'Ważny przez {seconds}s'
            },
            alert: {
                clear: {
                    header: 'Wyczyścić sekret TOTP?',
                    message: 'To usunie zapisany sekret. Aby go skonfigurować ponownie, zeskanuj kod QR lub wpisz go ręcznie.',
                    confirm: 'Wyczyść'
                }
            },
            toast: {
                saved: 'Sekret TOTP zapisany pomyślnie',
                saveFailed: 'Nie udało się zapisać sekretu',
                cleared: 'Sekret TOTP wyczyszczony',
                clearFailed: 'Nie udało się wyczyścić sekretu',
                loadFailed: 'Nie udało się wczytać sekretu',
                copySuccess: 'Sekret skopiowany do schowka',
                copyFailed: 'Nie udało się skopiować sekretu',
                openScannerFailed: 'Nie udało się otworzyć skanera',
                generateFailed: 'Nie udało się wygenerować tokenu',
                noSecret: 'Brak skonfigurowanego sekretu',
                scanSaved: 'Sekret zeskanowany i zapisany pomyślnie ({length} znaków)',
                invalidQR: 'Nieprawidłowy format kodu QR',
                scanFailed: 'Skanowanie nie powiodło się: {error}'
            }
        },
        manualRecords: {
            pageTitle: 'Zarządzanie rekordami ręcznymi',
            labels: {
                worker: 'Pracownik',
                month: 'Miesiąc'
            },
            actions: {
                create: 'Utwórz wpis ręczny'
            },
            loading: 'Ładowanie rekordów...',
            empty: 'Brak rekordów obecności w tym miesiącu.',
            status: {
                inProgress: 'W trakcie',
                checkedIn: 'Wejście',
                checkedOut: 'Wyjście',
                incomplete: 'Niekompletne'
            },
            edit: {
                title: 'Edytuj rekord obecności',
                info: 'Edytuj godziny wejścia i wyjścia. Status zostanie obliczony automatycznie na podstawie harmonogramu.',
                update: 'Zaktualizuj rekord'
            },
            create: {
                title: 'Utwórz wpis ręczny',
                create: 'Utwórz rekord'
            },
            fields: {
                date: 'Data',
                checkIn: 'Godzina wejścia',
                checkOut: 'Godzina wyjścia',
                checkOutOptional: 'Godzina wyjścia (opcjonalnie)',
                status: 'Status'
            },
            delete: {
                header: 'Usuń rekord',
                message: 'Czy na pewno chcesz usunąć ten rekord obecności? Tej operacji nie można cofnąć.'
            },
            toasts: {
                loaded: 'Wczytano {count} rekordów',
                loadFailed: 'Nie udało się wczytać rekordów',
                updated: 'Rekord zaktualizowany',
                updateFailed: 'Nie udało się zaktualizować rekordu',
                created: 'Wpis ręczny utworzony',
                createFailed: 'Nie udało się utworzyć rekordu',
                deleted: 'Rekord usunięty',
                deleteFailed: 'Nie udało się usunąć rekordu'
            }
        }
    },
    manualRecords: {
        pageTitle: 'Zarządzanie rekordami ręcznymi',
        labels: {
            worker: 'Pracownik',
            month: 'Miesiąc'
        },
        actions: {
            create: 'Utwórz wpis ręczny'
        },
        loading: 'Ładowanie rekordów...',
        empty: 'Brak rekordów obecności w tym miesiącu.',
        status: {
            inProgress: 'W trakcie',
            checkedIn: 'Wejście',
            checkedOut: 'Wyjście',
            incomplete: 'Niekompletne'
        },
        edit: {
            title: 'Edytuj rekord obecności',
            info: 'Edytuj godziny wejścia i wyjścia. Status zostanie obliczony automatycznie na podstawie harmonogramu.',
            update: 'Zaktualizuj rekord'
        },
        create: {
            title: 'Utwórz wpis ręczny',
            create: 'Utwórz rekord'
        },
        fields: {
            date: 'Data',
            checkIn: 'Godzina wejścia',
            checkOut: 'Godzina wyjścia',
            checkOutOptional: 'Godzina wyjścia (opcjonalnie)',
            status: 'Status'
        },
        delete: {
            header: 'Usuń rekord',
            message: 'Czy na pewno chcesz usunąć ten rekord obecności? Tej operacji nie można cofnąć.'
        },
        toasts: {
            loaded: 'Wczytano {count} rekordów',
            loadFailed: 'Nie udało się wczytać rekordów',
            updated: 'Rekord zaktualizowany',
            updateFailed: 'Nie udało się zaktualizować rekordu',
            created: 'Wpis ręczny utworzony',
            createFailed: 'Nie udało się utworzyć rekordu',
            deleted: 'Rekord usunięty',
            deleteFailed: 'Nie udało się usunąć rekordu'
        }
    },
    components: {
        attendanceCard: {
            inProgress: 'W trakcie'
        },
        geofenceCard: {
            location: 'Lokalizacja',
            atOffice: 'W biurze',
            outside: 'Poza biurem',
            verifying: 'Weryfikacja...',
            checking: 'Sprawdzanie lokalizacji...',
            youAreInside: 'Jesteś w środku',
            needToBeInside: 'Musisz być w strefie, aby wejść/wyjść'
        },
        qrFeedback: {
            titles: {
                validated: 'Kod QR zwalidowany',
                locationFailed: 'Weryfikacja lokalizacji nie powiodła się',
                validationFailed: 'Weryfikacja nie powiodła się'
            },
            messages: {
                success: 'Kod QR został pomyślnie zwalidowany!',
                locationErrorDefault:
                    'Weryfikacja lokalizacji nie powiodła się. Pozostań w granicach biura.',
                failedDefault: 'Weryfikacja kodu QR nie powiodła się. Spróbuj ponownie.'
            },
            actions: {
                tryAgain: 'Spróbuj ponownie',
                cancel: 'Anuluj'
            }
        }
    },
    scannerView: {
        ui: {
            initializing: 'Inicjowanie skanera...',
            notSupportedTitle: 'Skaner nieobsługiwany',
            notSupportedMessage: 'Skanowanie QR nie jest dostępne na tym urządzeniu.',
            verifyingLocation: 'Weryfikacja lokalizacji...',
            locationRequired: 'Wymagana lokalizacja',
            startStartingTitle: 'Uruchamianie skanera...',
            preparingCamera: 'Przygotowywanie kamery do wykrywania kodów QR',
            startScanButton: 'Rozpocznij skanowanie',
            verifyLocationButton: 'Zweryfikuj lokalizację',
            cancel: 'Anuluj',
            toggleFlashAria: 'Przełącz latarkę',
            debugPrefix: 'Debug: locationStatus = "{status}"'
        },
        alerts: {
            scannerErrorTitle: 'Błąd skanera',
            ok: 'OK',
            locationRequiredTitle: 'Wymagana lokalizacja',
            locationRequiredMessage:
                'Musisz być w granicach biura, aby skanować kody QR.'
        },
        toasts: {
            notSupported: 'Skanowanie QR nie jest obsługiwane na tym urządzeniu',
            genericError: 'Błąd skanera. Spróbuj ponownie.'
        },
        errors: {
            timeout:
                'Przekroczono czas żądania lokalizacji. Upewnij się, że GPS jest włączony i spróbuj ponownie.',
            failedOpenCamera: 'Nie udało się otworzyć skanera kamery',
            failedScan: 'Nie udało się zeskanować kodu QR'
        },
        location: {
            insideReady: 'Lokalizacja zweryfikowana. Gotowe do skanowania.',
            outsideBoundary: 'Musisz być w granicach biura, aby skanować kody QR.',
            poorAccuracy: 'Niska dokładność GPS. Przejdź w otwartą przestrzeń.',
            gpsUnavailable: 'Wymagany sygnał GPS. Przejdź w otwartą przestrzeń.',
            permissionRequired: 'Wymagane uprawnienie do lokalizacji.',
            checking: 'Sprawdzanie lokalizacji...',
            verificationRequired: 'Wymagana weryfikacja lokalizacji.'
        },
        headerTitle: 'Skaner QR'
    },
    notifications: {
        checkIn: {
            before: {
                title: 'Czas na wejście',
                body: 'Nie zapomnij zarejestrować wejścia po przybyciu do biura'
            },
            after: {
                title: 'Brak rejestracji wejścia',
                body: 'Nie zarejestrowałeś wejścia. Zrób to jak najszybciej'
            }
        },
        checkOut: {
            before: {
                title: 'Czas na wyjście',
                body: 'Nie zapomnij zarejestrować wyjścia przed opuszczeniem biura'
            },
            after: {
                title: 'Brak rejestracji wyjścia',
                body: 'Nie zarejestrowałeś wyjścia. Zrób to teraz'
            }
        },
        test: {
            title: 'Powiadomienie testowe',
            body: 'To jest testowe powiadomienie z Panelu Administratora Warden'
        },
        settings: {
            checkInBeforeLabel: 'Przypomnienie o wejściu (przed)',
            checkInBeforeDesc: 'Przypomnij mi przed rozpoczęciem pracy',
            checkInAfterLabel: 'Przypomnienie o wejściu (po)',
            checkInAfterDesc: 'Przypomnij, jeśli zapomnę zarejestrować wejście',
            checkOutBeforeLabel: 'Przypomnienie o wyjściu (przed)',
            checkOutBeforeDesc: 'Przypomnij mi przed zakończeniem pracy',
            checkOutAfterLabel: 'Przypomnienie o wyjściu (po)',
            checkOutAfterDesc: 'Przypomnij, jeśli zapomnę zarejestrować wyjście'
        }
    },
    logViewer: {
        title: 'Dzienniki',
        search: 'Wyszukaj dzienniki...',
        filters: {
            title: 'Filtry',
            active: 'Aktywne',
            category: 'Kategoria',
            level: 'Poziom',
            type: 'Typ',
            dateRange: 'Zakres dat',
            startDate: 'Data początkowa',
            endDate: 'Data końcowa',
            clearFilters: 'Wyczyść filtry'
        },
        categories: {
            all: 'Wszystkie kategorie',
            sync: 'Synchronizacja',
            auth: 'Autoryzacja',
            location: 'Lokalizacja',
            qr: 'QR',
            ble: 'BLE',
            api: 'API',
            admin: 'Administrator',
            system: 'System',
            security: 'Bezpieczeństwo'
        },
        levels: {
            all: 'Wszystkie poziomy',
            debug: 'Debugowanie',
            info: 'Informacja',
            warn: 'Ostrzeżenie',
            error: 'Błąd'
        },
        securityTypes: {
            all: 'Wszystkie typy',
            invalid_qr: 'Nieprawidłowy QR',
            expired_qr: 'Wygasły QR',
            replay_attempt: 'Atak powtórzeniowy',
            geofence_failure: 'Błąd geofence',
            repeated_failure: 'Powtarzające się błędy'
        },
        actions: {
            export: 'Eksportuj',
            clear: 'Wyczyść dzienniki',
            refresh: 'Odśwież',
            viewDetails: 'Pokaż szczegóły',
            hideDetails: 'Ukryj szczegóły'
        },
        states: {
            loading: 'Ładowanie dzienników...',
            empty: 'Nie znaleziono dzienników',
            emptyFiltered: 'Brak dzienników spełniających kryteria',
            emptyActivity: 'Brak dzienników aktywności',
            emptySecurity: 'Nie wykryto podejrzanej aktywności'
        },
        details: {
            title: 'Szczegóły dziennika',
            timestamp: 'Znacznik czasu',
            level: 'Poziom',
            category: 'Kategoria',
            message: 'Wiadomość',
            context: 'Dodatkowe szczegóły',
            workerId: 'ID pracownika',
            location: 'Lokalizacja',
            failureReason: 'Przyczyna błędu',
            attemptCount: 'Próby',
            syncStatus: 'Status synchronizacji',
            isPermanent: 'Rekord stały'
        },
        badges: {
            suspicious: 'PODEJRZANY',
            permanent: 'STAŁY'
        },
        count: {
            total: '{count} dzienników',
            suspicious: '{count} podejrzanych'
        },
        alerts: {
            clearTitle: 'Wyczyść wszystkie dzienniki',
            clearMessage: 'Czy na pewno chcesz usunąć wszystkie dzienniki? Ta operacja jest nieodwracalna.',
            clearConfirm: 'Wyczyść dzienniki',
            clearSecurityTitle: 'Wyczyść dzienniki bezpieczeństwa',
            clearSecurityMessage: 'Czy na pewno chcesz usunąć wszystkie dzienniki bezpieczeństwa? Ta operacja jest nieodwracalna.'
        },
        toasts: {
            exported: 'Dzienniki wyeksportowane pomyślnie',
            exportFailed: 'Nie udało się wyeksportować dzienników',
            cleared: 'Wszystkie dzienniki zostały wyczyszczone',
            clearFailed: 'Nie udało się wyczyścić dzienników',
            refreshed: 'Dzienniki odświeżone',
            refreshFailed: 'Nie udało się odświeżyć dzienników'
        }
    },
    profileAssignment: {
        noUser: {
            title: 'Nie ustawiono użytkownika',
            message: 'Skontaktuj się z administratorem, aby skonfigurować to urządzenie.',
            adminAccess: 'Dostęp administratora'
        },
        auth: {
            authenticating: 'Uwierzytelnianie...'
        },
        workerSelection: {
            title: 'Przypisz pracownika do urządzenia',
            subtitle: 'Wybierz pracownika, który będzie używał tego urządzenia',
            loading: 'Ładowanie pracowników...',
            searchPlaceholder: 'Wyszukaj pracowników po nazwisku lub ID...',
            workersFound: 'Znaleziono {count} pracownik(ów)',
            selectedWorker: 'Wybrany pracownik:',
            workerId: 'ID: {id}',
            noResults: 'Nie znaleziono pracowników pasujących do "{query}"',
            assignButton: 'Przypisz pracownika do urządzenia',
            selectWorker: 'Proszę wybrać pracownika'
        },
        errors: {
            connectionError: 'Nie można połączyć się z serwerem. Sprawdź połączenie.',
            loadWorkersFailed: 'Nie udało się załadować pracowników. Spróbuj ponownie.',
            invalidPassword: 'Nieprawidłowe hasło administratora. Spróbuj ponownie.',
            authFailed: 'Uwierzytelnianie nie powiodło się. Spróbuj ponownie.',
            workerNotFound: 'Nie znaleziono pracownika. Skontaktuj się z działem IT.',
            assignmentFailed: 'Nie udało się uwierzytelnić pracownika. Spróbuj ponownie.'
        }
    },
    vacation: {
        title: 'Urlop',
        summary: 'Informacje urlopowe',
        paidRemaining: 'Dostępne teraz',
        perYear: 'Naliczane rocznie',
        atYearStart: 'Na 1 stycznia',
        unpaidUsed: 'Na własny koszt',
        history: 'Historia',
        from: 'Od',
        to: 'do',
        adjustment: 'Korekta',
        noHistory: 'Brak rekordów',
        types: {
            VACATION: 'Urlop',
            WORKING_HOLIDAY: 'Dzień wolny',
            ADJUSTMENT: 'Korekta',
        },
        d: 'dni',
        h: 'g',
        error: 'Nie udało się załadować danych urlopowych. Spróbuj ponownie.',
        retry: 'Spróbuj ponownie'
    },
    update: {
        title: 'Dostępna aktualizacja',
        whatsNew: 'Co nowego',
        updateApp: 'Aktualizuj aplikację',
        installNewVersion: 'Zainstaluj nową wersję',
        later: 'Później',
        downloadingBundle: 'Pobieranie aktualizacji...',
        downloadingApk: 'Pobieranie instalatora...',
        downloadFailed: 'Pobieranie nie powiodło się. Spróbuj ponownie.',
        apkInstallHint: 'Zostaniesz poproszony o zainstalowanie aktualizacji.',
        readyToRestart: 'Aktualizacja pobrana! Uruchom ponownie aplikację, aby zastosować nową wersję.',
        restartNow: 'Uruchom ponownie'
    }
}
